import {ConfigurationInterpreter, DecisionKind} from '@viamedici-spc/configurator-ts';
import {fetchAll} from '../slices/productDataSlice';
import {selectSpcConfiguration, selectSpcSession} from '../selectors';
import {mergeSpcDecisions} from '../components/spc/util/spcUtils';
import {setInitialized} from '../slices/statusSlice';
import {spcExpliciteChoiceDecision} from '../util/values';
import {regionToValueMap} from '../valueMaps/regionToValueMap';
import {modeToValueMap} from '../valueMaps/modeToUsageMap';
import {migrateDecisions} from '../util/migrateDecisions';
import {productModelToHousingShape} from '../valueMaps/productModelToHousingShape';

export const sessionMiddleware = store => next => async action => {
	const result = next(action);
	if (action.type === 'spc/startSpcSession/fulfilled') {
		const deploymentName = action.meta.arg.deploymentName;
		console.log('sessionMiddleware spc/startSpcSession/fulfilled', action.meta.arg, store.getState());

		// product data for the model
		await store.dispatch(fetchAll({useAsDefault: true, modelId: deploymentName, region: store.getState().status.region}));

		const spcSession = selectSpcSession(store.getState());
		const spcConfiguration = selectSpcConfiguration(store.getState());

		const currentDecisions = spcSession?.getDecisions(DecisionKind.Explicit);
		// loaded via own storage
		let storedDecisions = store.getState().configuration?.data?.projects[0]?.project?.decisions ?? [];
		const formatVersion = store.getState().configuration?.data?.formatVersion;
		const mode = store.getState().configuration?.data?.projects[0]?.project?.lastPersistedBy;
		const model = productModelToHousingShape[store.getState().configuration?.data?.projects[0]?.project?.productModelId];

		if (formatVersion < 30) {
			storedDecisions = migrateDecisions(storedDecisions, mode, model);
		}

		// loaded via shortnumber Service
		let shortNumberDecisions = store.getState().shortNumber?.data?.loadedConfig?.configurationData?.decisions ?? [];
		shortNumberDecisions = shortNumberDecisions.map(dec => spcExpliciteChoiceDecision(dec.variableId, dec.featureValue));
		// merge loaded decisions

		//console.log('sessionMiddleware currentDecisions', storedDecisions, shortNumberDecisions);
		const loadedDecisions = mergeSpcDecisions(storedDecisions, shortNumberDecisions);
		//console.log('sessionMiddleware loadedDecisions', loadedDecisions);


		const fixedDecisions = [
			spcExpliciteChoiceDecision('shared::Context::CX_Region', regionToValueMap[store.getState().status.region]),
			spcExpliciteChoiceDecision('shared::Context::CX_Usage', modeToValueMap.external),
		];


		const defaultDecisions = []; //store.getState().productData.defaults;

		// remove eventual circular base profile decision in LightProfile Configurator
		/*
		if (store.getState().status.family === 'LightProfile') {
			defaultDecisions = defaultDecisions.filter(decision => decision.attributeId.localId !== 'HS_CircularBaseProfile');
		}
		*/

		let initialDecisions;
		if (loadedDecisions.length > 0) {
			initialDecisions = loadedDecisions;
		} else {
			initialDecisions = mergeSpcDecisions(defaultDecisions, fixedDecisions);
		}

		console.log('sessionMiddleware initial decisions', initialDecisions);
		await spcSession.makeManyDecisions(initialDecisions, {
			type: 'KeepExistingDecisions',
			conflictHandling: {type: 'Automatic'}, //{type: 'Manual', includeConstraintsInConflictExplanation: true}
		}).then(
			() => console.log('sessionMiddleware initial decisions made'),
			error => console.error('sessionMiddleware initial decisions failed', error)
		);

		// init done
		store.dispatch(setInitialized({initialized: true}));
	}
	return result;
};
